import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import siteConfig from '../config/site-config';

/** SPA 兜底：nginx 未把 /p/ 转到后端时，由前端解析短码再进入选点页 */
function PickPointShareRedirect() {
  const { code } = useParams();
  const [error, setError] = useState('');

  useEffect(() => {
    const shortCode = String(code || '').trim();
    if (!shortCode) {
      setError('缺少选点短码');
      return undefined;
    }
    let cancelled = false;
    fetch(`${siteConfig.getApiUrl()}/pick-point/resolve?c=${encodeURIComponent(shortCode)}`)
      .then(async (response) => {
        const data = await response.json().catch(() => ({}));
        if (!response.ok || !data.success || !data.token) {
          throw new Error(data.error || '选点链接无效');
        }
        if (!cancelled) {
          window.location.replace(`/m/pick?t=${encodeURIComponent(data.token)}`);
        }
      })
      .catch((requestError) => {
        if (!cancelled) setError(requestError.message || '选点链接无效');
      });
    return () => {
      cancelled = true;
    };
  }, [code]);

  return (
    <main style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff7ed', fontFamily: 'system-ui, sans-serif' }}>
      <p style={{ color: error ? '#b42318' : '#9a3412' }}>{error || '正在打开手机选点…'}</p>
    </main>
  );
}

export default PickPointShareRedirect;
